export default {
	methods: {
		images() {
			const self = this;

			return {
				isFullFilled(url) {
					// const tinyUrl = `https://imageproxy.tiny.cloud/2/image?url=${url}&apiKey=${self.vars.tinyKey}`;
					const tinyUrl = url;
					// const tinyUrl = `https://imageproxy.tiny.cloud/2/image?url=${url}&apiKey=ytr64h3ugg0asgqv4vodkw55grhyzawe7rz2ox77svjmd1b6`;
					return new Promise(((resolve, reject) => {
						try {
							fetch(tinyUrl).then(r => r.blob()).then((blobFile) => {
								let reader;
								switch (blobFile.type) {
								case 'image/jpeg': case 'image/jpg': case 'image/png': case 'image/gif': case 'image/webp':
									reader = new FileReader();
									reader.readAsDataURL(blobFile);
									reader.onloadend = function () {
										const base64data = reader.result;

										const canvas = document.createElement('canvas');
										const context = canvas.getContext('2d');
										const img = new Image();

										img.onload = function () {
											canvas.width = this.width;
											canvas.height = this.height;
											context.drawImage(img, 0, 0, this.width, this.height);

											const i = context.getImageData(0, 0, this.width, this.height).data;
											const l = i.length;

											if (i[0] === 255 && i[1] === 255 && i[2] === 255 && i[3] === 255 && i[l - 1] === 255 && i[l - 2] === 255 && i[l - 3] === 255 && i[l - 4] === 255) {
												resolve(true);
											} else {
												resolve(false);
											}
										};

										img.src = base64data;
									};

									break;

								default:
									reject();
								}
							});
						} catch (e) {
							reject();
						}
					}));
				},
				avatar(user = null) {
					if (user) {
						if (user.image_url) return user.image_url;
					} else if (self.$store.getters.user) {
						if (self.$store.getters.user.image_url) return self.$store.getters.user.image_url;
					}

					return require('../../assets/img/placeholder/avatar.jpg');
				},
				deal(item, size = 200) {
					if (item.image_url) return self.images().adaptative(item.image_url, size);
					return self.$vars.defaultImageDeal;
				},
				adaptative(imageUrl, size) {
					const match = imageUrl.match(/https?:\/\/img\.michollo\.com\/(?:r\/(?:\d+)\/)?(.+)/i);
					if (match) return `${self.vars.cdnPath}/r/${size}/${match[1]}`;

					return imageUrl;
				},
			};
		},
	},
};
